import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { IDashboardState, IState } from '../states';

function createSpecialFeaturesSelectors(
  dashboardFeatureSelector: MemoizedSelector<IState, IDashboardState, DefaultProjectorFn<IDashboardState>>,
) {
  const selectIsShelfReportActive = createSelector(
    dashboardFeatureSelector,
    (state) => state.specialFeatures.isShelfReportActive,
  );

  const selectSpecialLabel = createSelector(dashboardFeatureSelector, (state) => state.specialFeatures.specialLabel);

  const selectIsScanOrdersActive = createSelector(
    dashboardFeatureSelector,
    (state) => state.specialFeatures.isScanOrdersActive,
  );

  const selectScansForFulfillmentAmount = createSelector(
    dashboardFeatureSelector,
    (state) => state.specialFeatures.scansForFulfillmentAmount,
  );

  const selectLateCarrierSlaOrders = createSelector(
    dashboardFeatureSelector,
    (state) => state.specialFeatures.lateCarrierSlaOrders,
  );

  const selectLateDeliveryPromiseOrders = createSelector(
    dashboardFeatureSelector,
    (state) => state.specialFeatures.lateDeliveryPromiseOrders,
  );

  const selectSpecialFeaturesSettings = createSelector(
    dashboardFeatureSelector,
    ({ specialFeatures: { isScanOrdersActive, isShelfReportActive, specialLabel } }) => ({
      specialFeatures: {
        isScanOrdersActive,
        isShelfReportActive,
        specialLabel,
      },
    }),
  );

  return {
    selectIsShelfReportActive,
    selectSpecialLabel,
    selectIsScanOrdersActive,
    selectScansForFulfillmentAmount,
    selectLateCarrierSlaOrders,
    selectLateDeliveryPromiseOrders,
    selectSpecialFeaturesSettings,
  };
}

export default createSpecialFeaturesSelectors;
